var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnauthorized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-401-error-unauthorized",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    svg#freepik_stories-401-error-unauthorized:not(.animated) .animable {opacity: 0;}svg#freepik_stories-401-error-unauthorized.animated #freepik--error-401--inject-185 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-401-error-unauthorized.animated #freepik--Character--inject-185 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-185",
    className: "animable",
    style: {
      transformOrigin: "250px 215.19px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "250px 382.525px"
    },
    id: "el5j7vhjp25v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.54,
    y: 390.79,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "95.1px 390.915px"
    },
    id: "elm0l7dawk5ad",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.33,
    y: 398,
    width: 30.17,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "148.415px 398.125px"
    },
    id: "elsgon4he2zmn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.85,
    y: 400.07,
    width: 38.25,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "75.975px 400.195px"
    },
    id: "elyf1kc8arumk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 434,
    y: 399.53,
    width: 15.9,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "441.95px 399.655px"
    },
    id: "elkuthtc5g35e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.47,
    y: 399.53,
    width: 39.32,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "411.13px 399.655px"
    },
    id: "elkd06ijglb9b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 390.66,
    width: 30.33,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "265.165px 390.785px"
    },
    id: "ell9esk4pi0n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.67,
    y: 390.66,
    width: 72.1,
    height: 0.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "320.72px 390.785px"
    },
    id: "elen6muy2nqbt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "140.46px 196.4px"
    },
    id: "ely8lm296eah",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "356.75px 196.4px"
    },
    id: "el7socfyvy4ol",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2hba7mk8r8c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.19,
    y: 199.2,
    width: 21.67,
    height: 199.67,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "351.025px 299.035px",
      transform: "rotate(45deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "361.93 303.45 346.61 288.12 325.72 309.01 339.77 331.42 361.93 303.45",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "343.825px 309.77px"
    },
    id: "elys9g29lk2ui",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7yaz3xh87rc"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 357.63,
    y: 209.41,
    width: 7.22,
    height: 199.67,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "361.24px 309.245px",
      transform: "rotate(-135deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elpptfucgx2qa"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.19,
    y: 204.31,
    width: 21.67,
    height: 199.67,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "351.025px 304.145px",
      transform: "rotate(-45deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elj7aad03cbbf"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 357.63,
    y: 194.09,
    width: 7.22,
    height: 199.67,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "361.24px 293.925px",
      transform: "rotate(135deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el2oz7xps1sva"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.86,
    y: 239.82,
    width: 16.87,
    height: 155.4,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "115.295px 317.52px",
      transform: "rotate(45deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "123.78 320.95 111.85 309.03 95.6 325.29 106.53 342.72 123.78 320.95",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "109.69px 325.875px"
    },
    id: "elyxrd6e6il5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1phur196cw4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.43,
    y: 247.77,
    width: 5.62,
    height: 155.4,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "123.24px 325.47px",
      transform: "rotate(-135deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elocv2y36f2ls"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 106.86,
    y: 243.8,
    width: 16.87,
    height: 155.4,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "115.295px 321.5px",
      transform: "rotate(-45deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elwu2lszujk2r"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 120.43,
    y: 235.85,
    width: 5.62,
    height: 155.4,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "123.24px 313.55px",
      transform: "rotate(135deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 301.26,
    y: 275.11,
    width: 17.61,
    height: 107.28,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "310.065px 328.75px"
    },
    id: "elah0onsxr8ga",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "318.87 319.69 301.26 319.69 301.26 332.56 318.87 328.76 318.87 319.69",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "310.065px 326.125px"
    },
    id: "elso68y90bqkk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elafej853nr7k"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 318.87,
    y: 275.11,
    width: 5.87,
    height: 107.28,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "321.805px 328.75px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 116.79,
    y: 275.11,
    width: 17.61,
    height: 107.28,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "125.595px 328.75px"
    },
    id: "elgo3276wmm87",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.39 319.69 116.79 319.69 116.79 332.56 134.39 328.76 134.39 319.69",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "125.59px 326.125px"
    },
    id: "elqfisov03yvr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkv6lel6lpb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.39,
    y: 275.11,
    width: 5.87,
    height: 107.28,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "137.325px 328.75px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 103.36,
    y: 290.84,
    width: 224.75,
    height: 33.02,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "215.735px 307.35px"
    },
    id: "elpr74n1sta5j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1qftq0rvrbc"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 328.11,
    y: 290.84,
    width: 3.3,
    height: 33.02,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "329.76px 307.35px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "242.73 257.17 198.79 257.17 167.72 288.24 167.72 332.18 198.79 363.25 242.73 363.25 273.8 332.18 273.8 288.24 242.73 257.17",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "220.76px 310.21px"
    },
    id: "elpu59p15af5k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.72 262.02 200.8 262.02 172.57 290.25 172.57 330.17 200.8 358.4 240.72 358.4 268.95 330.17 268.95 290.25 240.72 262.02",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "220.76px 310.21px"
    },
    id: "elyvezka96c5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.19,314.82l5.62-.5a7.89,7.89,0,0,0,.74,3,2.86,2.86,0,0,0,2.61,1.65,2.36,2.36,0,0,0,2-.84,3,3,0,0,0,.69-2,3,3,0,0,0-.66-1.9,6.5,6.5,0,0,0-3-1.58,11.31,11.31,0,0,1-5.54-3.3,8,8,0,0,1-1.67-5.26,9.4,9.4,0,0,1,.85-4,6.65,6.65,0,0,1,2.57-2.93,8.77,8.77,0,0,1,4.7-1.07,7.55,7.55,0,0,1,5.59,1.94c1.28,1.29,2,3.35,2.29,6.17l-5.57.47a5.14,5.14,0,0,0-.93-2.68,2.47,2.47,0,0,0-2-.83,1.93,1.93,0,0,0-1.55.62,2.27,2.27,0,0,0-.52,1.51,1.75,1.75,0,0,0,.43,1.17,4.1,4.1,0,0,0,2,1,19.67,19.67,0,0,1,5.55,2.4,7.12,7.12,0,0,1,2.44,3,10.19,10.19,0,0,1,.76,4,11.34,11.34,0,0,1-1,4.82,7.58,7.58,0,0,1-2.85,3.36,8.52,8.52,0,0,1-4.6,1.14q-4.87,0-6.75-2.68A12.8,12.8,0,0,1,182.19,314.82Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "190.891px 310.129px"
    },
    id: "elvpy5v8lqsi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.17,296.6h18v6.73h-6v20.49h-5.91V303.33h-6Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "210.17px 310.21px"
    },
    id: "el8cr4ryypqex",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.14,310.23q0-6.66,2.61-10.38a9.1,9.1,0,0,1,14.62-.06Q240,303.44,240,310a22.76,22.76,0,0,1-1.13,7.83,10.52,10.52,0,0,1-3.26,4.75,8.26,8.26,0,0,1-5.31,1.7,9.15,9.15,0,0,1-5.35-1.47,10.15,10.15,0,0,1-3.44-4.64A20.83,20.83,0,0,1,220.14,310.23Zm5.91,0q0,4.13,1.08,5.92a3.31,3.31,0,0,0,5.87,0c.7-1.18,1-3.29,1-6.33a11.19,11.19,0,0,0-1.08-5.62,3.35,3.35,0,0,0-3-1.77,3.25,3.25,0,0,0-2.87,1.8Q226.05,306.11,226.05,310.27Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "230.073px 310.213px"
    },
    id: "elnooizb5no0b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.11,296.6h9.82a5.59,5.59,0,0,1,4.81,2.18,10.3,10.3,0,0,1,1.59,6.18,10.51,10.51,0,0,1-1.74,6.44,6.2,6.2,0,0,1-5.31,2.32H249v10.1h-5.93ZM249,308.21h1.45a2.93,2.93,0,0,0,2.4-.85,3.29,3.29,0,0,0,.69-2.16A3.79,3.79,0,0,0,253,303a2.51,2.51,0,0,0-2.25-.89H249Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "251.21px 310.204px"
    },
    id: "elbue8abkvaqc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.35,102.75a13.68,13.68,0,0,0-3.1.37h0c-1.32-3-4.25-4.87-8.2-4.87A15.53,15.53,0,0,0,391.6,101h0c-1.68-5.64-6.71-9.41-13.73-9.41-10,0-20.45,7.64-24.23,17.4a12.12,12.12,0,0,0-2.82-.32l-.94,0c-8.61.58-8,13.58.67,13.58H412a6.77,6.77,0,0,0,5.47-2.75,15.78,15.78,0,0,0,2.39-4.76C421.76,108.12,418,102.75,411.35,102.75Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "382.039px 106.92px"
    },
    id: "elpgy3iu0iy5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.36,45.13c-1.34-8.88-8.42-15.07-18.77-15.07-8.48,0-17.22,4.15-23.73,10.54h0A10,10,0,0,0,122,38.16c-7.18,0-14.71,5.82-16.83,13a13,13,0,0,0-.53,3.26h0l-.15.1c-5.94,4-3,13.39,4.24,13.39H172a7.24,7.24,0,0,0,6.1-3.25,18.66,18.66,0,0,0,2.27-4.88C182.58,52.14,178.61,45.85,171.36,45.13Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "141.146px 48.9851px"
    },
    id: "elgnvo7b9u3ql",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.88,144.3c-1.84-12.21-11.57-20.72-25.8-20.72-11.67,0-23.68,5.71-32.62,14.49h0a13.67,13.67,0,0,0-9.42-3.36c-9.86,0-20.23,8-23.14,17.87a17.88,17.88,0,0,0-.73,4.48l0,0-.2.13c-8.19,5.57-4.13,18.41,5.77,18.41H244a15.74,15.74,0,0,0,15.14-11.06l0-.12C262.32,153.93,256.85,145.28,246.88,144.3Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "205.315px 149.59px"
    },
    id: "elohrfxu2upn",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-185",
    className: "animable",
    style: {
      transformOrigin: "250px 416.24px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-185",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "250px 416.24px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--error-401--inject-185",
    className: "animable animator-active",
    style: {
      transformOrigin: "221.725px 97.05px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.74,128.92H78.54V106.26l50.2-59.67h24v61h12.45v21.38H152.76v18.54h-24Zm0-21.38V76.33l-26.52,31.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "121.865px 97.05px"
    },
    id: "elxhyn3v8063",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.91,46.59V147.46H337V81.36A84.88,84.88,0,0,1,324,89.68a102.47,102.47,0,0,1-15.87,6.09V73.18q14.07-4.55,21.85-10.9a44.41,44.41,0,0,0,12.18-15.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "336.52px 97.025px"
    },
    id: "elgjav32u4jpm",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-185",
    className: "animable",
    style: {
      transformOrigin: "276.771px 226.668px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.82,173.19c-.44.79-.78,1.36-1.17,2s-.78,1.24-1.17,1.86c-.79,1.22-1.63,2.4-2.48,3.58a82.43,82.43,0,0,1-5.51,6.81,65.42,65.42,0,0,1-6.41,6.25,45.82,45.82,0,0,1-7.67,5.38,18.47,18.47,0,0,1-2.69,1.29,17.11,17.11,0,0,1-3,.84,22.33,22.33,0,0,1-5.53.26,34.2,34.2,0,0,1-9.33-2.16,56,56,0,0,1-8-3.8,57.91,57.91,0,0,1-7.2-4.86,3.5,3.5,0,0,1,3.42-6l.18.07a88.7,88.7,0,0,0,14.53,4.41,27.19,27.19,0,0,0,6.65.55,9.43,9.43,0,0,0,2.56-.47,5,5,0,0,0,.89-.39c.28-.16.33-.21.9-.6A53.25,53.25,0,0,0,291,178.36c1.57-1.92,3.1-3.91,4.55-6,.74-1,1.44-2.07,2.15-3.11l1-1.56.94-1.47.16-.25a7,7,0,0,1,12,7.19Z",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "281.512px 182.164px"
    },
    id: "el4az2d5rvhsd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.74,185.46l-7.67-5.08-3.25,10.2a9.67,9.67,0,0,0,9.86-.5Z",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "251.28px 186.038px"
    },
    id: "el8o57a4ma2li",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,181.91l-.6,3.25a3.1,3.1,0,0,0,1.22,3.08l3.17,2.34,3.25-10.2-3.08-.9A3.13,3.13,0,0,0,242,181.91Z",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "245.193px 184.966px"
    },
    id: "elbc2phw9jgo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.06,156.94c-7.81,1.23-15.71,10.4-20.46,18.95a30.35,30.35,0,0,0,13.53,12.42s9.26-8.76,13-15.24S319.41,155.77,312.06,156.94Z",
    style: {
      fill: "rgb(68, 8, 78)",
      transformOrigin: "305.73px 172.581px"
    },
    id: "el56i8vwzty5y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eluc38pvlmks"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312.06,156.94c-7.81,1.23-15.71,10.4-20.46,18.95a30.35,30.35,0,0,0,13.53,12.42s9.26-8.76,13-15.24S319.41,155.77,312.06,156.94Z",
    style: {
      opacity: 0.2,
      transformOrigin: "305.73px 172.581px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M291.9,173.93a8.89,8.89,0,0,0-1.67,2.79c1.95,3,6.58,11,15.22,12.7a4,4,0,0,0,1.81-2.13S297.32,182.39,291.9,173.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "298.745px 181.675px"
    },
    id: "el4lvdac8u1y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.53,156.67a104.52,104.52,0,0,0-28.57-.82c-7.1.91-12.4,7.44-12.35,14.59a131.71,131.71,0,0,0,2,22.25c-2.61,13.75-3.55,32.44-.8,36.56l49.19.69c2.11-5.88-.54-31.33,2.27-57.9A14.06,14.06,0,0,0,343.53,156.67Z",
    style: {
      fill: "rgb(68, 8, 78)",
      transformOrigin: "328.749px 192.588px"
    },
    id: "elmxb9lk715wo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elm83gz9sslci"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325,229.31c-2.81-22.13,0-59.14,0-59.52l1,.08c0,.37-2.79,37.28,0,59.31Z",
    style: {
      opacity: 0.2,
      transformOrigin: "324.876px 199.55px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M319.65,156.54c1.69-.63,1.06-1.57,1.06-1.57s-7.68,0-13,1.43c-.81.86.06,2,.06,2S314.62,158.42,319.65,156.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "314.095px 156.685px"
    },
    id: "el6mnhcxyui5n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elaikxbqqzg0t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.79,155s-3.17,5.86,1.07,11.19c-3.36,0-5.53,5.73-5.53,5.73s-6.56-9.12,1.83-16.41C320.63,154.78,322.79,155,322.79,155Z",
    style: {
      opacity: 0.2,
      transformOrigin: "319.875px 163.444px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M319.4,157.84c-.82,3.58,6.39,10.33,6.39,10.33s12.75-6.16,13.56-9.69Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "329.342px 163.005px"
    },
    id: "elobpgv8gv3i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el56zsc1hgbjv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.18,178.79c-1.36,2.62.45,14,5.7,18.81.06-4.7.2-9.69.5-14.82Z",
    style: {
      opacity: 0.2,
      transformOrigin: "351.063px 188.195px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M336.69,137.25l-13.16,8.64c1.56,3.82,2.29,7.8-2.21,9.64a3.12,3.12,0,0,0,0,5.79,15,15,0,0,0,4.12.87,24.68,24.68,0,0,0,12.38-2,3.15,3.15,0,0,0,1.14-4.67C335.51,150.64,335.93,142.16,336.69,137.25Z",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "329.463px 149.778px"
    },
    id: "elk3rhvpsmmji",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elexbetox3sa6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.33,140.77l-7.79,5.11a17.47,17.47,0,0,1,1,3.24c3.11-.18,7.17-2.64,7.25-5.21A7.35,7.35,0,0,0,331.33,140.77Z",
    style: {
      opacity: 0.2,
      transformOrigin: "327.675px 144.945px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M322.08,120.77c3.35-.07,4.26,4.74,3,6.37,2.54.55,3.77,3.52,3,5s-3.71,3.15-6.33,2.49c-4.49-1.12-5.26-4.85-4-6.55C315.35,126.1,316.57,120,322.08,120.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "322.444px 127.741px"
    },
    id: "el1f8ilc1v90y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el74vpbwzrpzb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.08,120.77c3.35-.07,4.26,4.74,3,6.37,2.54.55,3.77,3.52,3,5s-3.71,3.15-6.33,2.49c-4.49-1.12-5.26-4.85-4-6.55C315.35,126.1,316.57,120,322.08,120.77Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "322.444px 127.741px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M341,128.7c-1,7.89-1.19,12.56-5.46,16.34-6.43,5.67-16,1.31-17.36-6.75-1.24-7.25.61-18.94,8.58-21.52A11,11,0,0,1,341,128.7Z",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "329.462px 131.931px"
    },
    id: "elngfnk2kvqe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.05,134.73c-3.35,0-4.09-4.88-2.81-6.46-2.52-.65-3.64-3.66-2.86-5.14s3.81-3,6.41-2.27c4.45,1.28,5.1,5,3.81,6.69C347,129.65,345.53,135.67,340.05,134.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "339.924px 127.75px"
    },
    id: "elont60394dme",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el6547rszoyc7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.05,134.73c-3.35,0-4.09-4.88-2.81-6.46-2.52-.65-3.64-3.66-2.86-5.14s3.81-3,6.41-2.27c4.45,1.28,5.1,5,3.81,6.69C347,129.65,345.53,135.67,340.05,134.73Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "339.924px 127.75px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eltcuqaostjx"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332,130a3.17,3.17,0,0,1,2.41.31A6.38,6.38,0,0,1,332,130Z",
    style: {
      opacity: 0.2,
      transformOrigin: "333.205px 130.106px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elgzbu48r9ua"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332,130.54a2.61,2.61,0,0,1,2.05.82A5.3,5.3,0,0,1,332,130.54Z",
    style: {
      opacity: 0.2,
      transformOrigin: "333.025px 130.948px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elyje1jpnna2h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.47,129.39a.79.79,0,0,0-1.1.31A1.5,1.5,0,0,0,319.47,129.39Z",
    style: {
      opacity: 0.2,
      transformOrigin: "318.92px 129.495px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el2iq03mafwuo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.48,130s-.61-.09-.93.82A2.19,2.19,0,0,0,319.48,130Z",
    style: {
      opacity: 0.2,
      transformOrigin: "319.015px 130.409px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M343.38,136.74a7.49,7.49,0,0,1-4.22,3.48c-2.28.66-3.19-1.62-2.37-4,.75-2.13,2.82-5.05,5-4.66S344.58,134.63,343.38,136.74Z",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "340.24px 135.93px"
    },
    id: "elv5r99zs95n8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.4,130c0,.64-.41,1.14-.84,1.11s-.73-.58-.68-1.23.41-1.14.84-1.11S330.45,129.37,330.4,130Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "329.64px 129.94px"
    },
    id: "elck20jyj3zx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.2,141.75c-.82.16-1.57-.16-1.67-.7s.5-1.1,1.32-1.26,1.57.16,1.67.7S328,141.6,327.2,141.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "327.025px 140.77px"
    },
    id: "elfz6pt6to2k8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.65,129.31c0,.64-.42,1.14-.84,1.11s-.74-.58-.69-1.23.42-1.14.84-1.11S321.69,128.66,321.65,129.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "320.884px 129.25px"
    },
    id: "elvcyhe9r43um",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.64,135.75c-4.68.32-5.58,2.6-4.76,3.6s2.82,0,2.82,0,3.79.81,4.9-.4c1.79.76,4.52-.66,3.75-1.74S327.65,135.47,323.64,135.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "324.547px 137.74px"
    },
    id: "el7p1r9lsrhk9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el20xsjkr5w83"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.64,135.75c-4.68.32-5.58,2.6-4.76,3.6s2.82,0,2.82,0,3.79.81,4.9-.4c1.79.76,4.52-.66,3.75-1.74S327.65,135.47,323.64,135.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "324.547px 137.74px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M323.78,130a22.82,22.82,0,0,1-3.45,5.29,3.77,3.77,0,0,0,3.05.81Z",
    style: {
      fill: "rgb(255, 86, 82)",
      transformOrigin: "322.055px 133.078px"
    },
    id: "elbqkrddnin3w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.81,126.64a.48.48,0,0,0,.18-.06.38.38,0,0,0,.11-.53,3.78,3.78,0,0,0-3-1.79.38.38,0,0,0,0,.76h0a3,3,0,0,1,2.35,1.44A.38.38,0,0,0,331.81,126.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "330.442px 125.451px"
    },
    id: "el67rfrmbj61f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.78,125.89a.4.4,0,0,0,.32-.17,3,3,0,0,1,2.36-1.38.38.38,0,0,0,0-.76,3.74,3.74,0,0,0-3,1.72.37.37,0,0,0,.11.52A.33.33,0,0,0,318.78,125.89Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "320.118px 124.735px"
    },
    id: "elbp70chwhh39",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.69,310.8c2.24-36.08,1.74-73.1-2.15-81.16l-25.75-.39S307,289.57,308,313.6c1.05,25,3.29,90,3.29,90l14.9.18S334.93,338.71,331.69,310.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "318.406px 316.515px"
    },
    id: "elu9kapcyz4b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el4vul2pqkxw7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.8,255.65c-8.79,9.6-4.68,36.18-.85,50.82C333,288.16,333.28,269.93,332.8,255.65Z",
    style: {
      opacity: 0.2,
      transformOrigin: "330.297px 281.06px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M326,405.66l-13.1-.17a3.63,3.63,0,0,0-2.32.69c-3.8,3-6.69,3.09-11,3.86-5.17.93-2.61,6.13,1.2,6.19,6.3.1,5.77-.13,11.15-.05l3.72.05,1.68-1.71,1.49,1.71h6.88a1.26,1.26,0,0,0,1.28-1.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "311.829px 410.87px"
    },
    id: "elrsqm3ggvlwn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,407c-.23,0-17.19-.54-17.19-.54l-.69-6.09,18.81.42Z",
    style: {
      fill: "rgb(68, 8, 78)",
      transformOrigin: "318.525px 403.685px"
    },
    id: "elwzusmmqr4v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.93,310.8C359.17,274.72,358,238,353,229.94l-31.05-.4s12.35,60,16.69,84.06c4.51,25,16.65,90,16.65,90l14.93.18S369,338.71,361.93,310.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "346.085px 316.66px"
    },
    id: "elle3ixa37gn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.93,405.66l-13.11-.17a3.62,3.62,0,0,0-2.31.69c-3.8,3-2.06,3.09-6.37,3.86-5.17.93-2.62,6.13,1.19,6.19,6.3.1,5.78-.13,11.15-.05l5.84.05.77-1.71,1,1.71h1.54a1.26,1.26,0,0,0,1.25-1.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "359.057px 410.871px"
    },
    id: "el7g3db5eiam6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.92,407c-.24,0-17.27-.54-17.27-.54L353,400.33l18.87.42Z",
    style: {
      fill: "rgb(68, 8, 78)",
      transformOrigin: "362.46px 403.665px"
    },
    id: "elun1t3ci4bls",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.31,154.29s-3.69,6.57.55,11.9c-3.36,0-5.56,3.64-5.56,3.64s-4.47-9,2.14-15C320.9,154.15,323.31,154.29,323.31,154.29Z",
    style: {
      fill: "rgb(68, 8, 78)",
      transformOrigin: "320.341px 162.054px"
    },
    id: "elsjf44pum7cj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.33,232.68c-17.57.73-37.72.95-50.32,0a.45.45,0,0,1-.35-.19,8,8,0,0,1-1.09-4.64.47.47,0,0,1,.48-.43c16.63.45,33.16.43,50.54,0a.48.48,0,0,1,.45.29,10.44,10.44,0,0,1,.74,4.54A.46.46,0,0,1,354.33,232.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "328.674px 230.366px"
    },
    id: "elu76rozhacqq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxd5q8gq595"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.33,232.68c-17.57.73-37.72.95-50.32,0a.45.45,0,0,1-.35-.19,8,8,0,0,1-1.09-4.64.47.47,0,0,1,.48-.43c16.63.45,33.16.43,50.54,0a.48.48,0,0,1,.45.29,10.44,10.44,0,0,1,.74,4.54A.46.46,0,0,1,354.33,232.68Z",
    style: {
      opacity: 0.2,
      transformOrigin: "328.674px 230.366px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M320,227.14a19.08,19.08,0,0,0,.53,6.59c3.81.59,11.63.15,11.63.15a38.14,38.14,0,0,0-.24-6.64C325.92,227,320,227.14,320,227.14Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "326.063px 230.569px"
    },
    id: "elq031ng8zf3d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.13,166.72l.57.51.45.42.85.82c.55.54,1.05,1.08,1.56,1.63,1,1.09,1.95,2.22,2.85,3.36a76.76,76.76,0,0,1,5,7.06,89.91,89.91,0,0,1,7.53,15.24c.27.71.48,1.14.86,2.35a17.45,17.45,0,0,1,.64,3,23.11,23.11,0,0,1-.07,5.35,37.49,37.49,0,0,1-2.4,8.91,61.09,61.09,0,0,1-3.74,7.71,62.08,62.08,0,0,1-4.67,7,3.5,3.5,0,0,1-6.07-3.29l.06-.17a110.47,110.47,0,0,0,4.23-14.39,31.27,31.27,0,0,0,.76-6.65,10.28,10.28,0,0,0-.32-2.57,10,10,0,0,0-1-2.17,109.22,109.22,0,0,0-7.49-12.77c-1.37-2-2.83-4-4.33-5.82-.75-.94-1.53-1.83-2.3-2.71l-1.16-1.27-.56-.59-.26-.27-.17-.16a7,7,0,0,1,9.19-10.57Z",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "359.554px 198.196px"
    },
    id: "eliae9ox0jag",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.51,158.06c7.79,1.35,15.55,10.63,20.18,19.25A30.35,30.35,0,0,1,353,189.53s-9.14-8.9-12.79-15.42S339.18,156.79,346.51,158.06Z",
    style: {
      fill: "rgb(68, 8, 78)",
      transformOrigin: "352.633px 173.744px"
    },
    id: "el1as6rpidx7wk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.42,175.34a9.08,9.08,0,0,1,1.63,2.82c-2,3-6.74,10.93-15.41,12.48a4,4,0,0,1-1.77-2.16S360.88,183.72,366.42,175.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "359.46px 182.99px"
    },
    id: "elziyogsm510m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.87,157.36c-1.61-.69-1-1.6-1-1.6s7.41.26,12.48,1.87c.75.89-.13,2-.13,2S345.65,159.41,340.87,157.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "346.205px 157.695px"
    },
    id: "el1wi8iaygnn2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8fbbxi3do9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.93,155.56s-1.68,5.86-9.36,10.64c3.36,0,5.61,6.13,5.61,6.13s7-8.22,5.38-16.33C340.09,155.28,338.93,155.56,338.93,155.56Z",
    style: {
      opacity: 0.2,
      transformOrigin: "335.187px 163.918px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M338.71,154.5s-2,6.34-9.14,11.7c3.36,0,5.69,3.63,5.69,3.63s6.88-5.72,5.3-13.83A6.76,6.76,0,0,0,338.71,154.5Z",
    style: {
      fill: "rgb(68, 8, 78)",
      transformOrigin: "335.183px 162.165px"
    },
    id: "el0n48ldp82bj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.91,178.57c-.46,8.64-5.93,10.7-6.7,10.7s-6-2.06-5.54-10.7l6.25-2.46Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "339.776px 182.69px"
    },
    id: "elz6b16wf7dg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.37,226.1l-6.16,5.3,8.17,5.31s5-5.48,2.52-8.6Z",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "358.9px 231.405px"
    },
    id: "elz992qjssqf9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.52,239.81l3.17,1.37a2.82,2.82,0,0,0,3.49-1.05l2.2-3.42-8.17-5.31-2.13,4.65A2.82,2.82,0,0,0,352.52,239.81Z",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "356.102px 236.407px"
    },
    id: "elza4j7hoq3h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.7,119.13c-5.49.75-3.65,2.49,8.59,4.05s15.31.33,15.31.33S327.54,119.1,317.7,119.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "328.18px 121.55px"
    },
    id: "elsst0h14l08",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.39,125.89s-10.75-4.37-27.69-6.76c-.21-2.49,1.84-5.13,1.84-5.13s-3.78-1.89-2.61-5.5,6.58-3.14,12.89-6c2.31,2.54,8.66,6.67,13,7.2,1.07,2.21,3.87,7.74,8.41,9.87-.07,2.41-4.58,3-4.58,3A4.6,4.6,0,0,1,345.39,125.89Z",
    style: {
      fill: "rgb(68, 8, 78)",
      transformOrigin: "333.968px 114.195px"
    },
    id: "el7p3oabslu1j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elklzrpeusdhh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.64,122.57c-3.93-3.57-17.89-10.09-27.1-8.57,0,0-2.05,2.65-1.84,5.13,16.94,2.39,27.69,6.76,27.69,6.76A4.6,4.6,0,0,0,346.64,122.57Z",
    style: {
      opacity: 0.3,
      transformOrigin: "332.164px 119.832px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M331.44,109.84c-1.21,6.16-5.41,7.27-6,7.21s-4.19-1.88-3-8l4.83-1.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "326.82px 112.381px"
    },
    id: "elax3sci3clxw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.75,210.78a2.5,2.5,0,0,1-2.48-2.2l-7.14-58.19a2.5,2.5,0,0,1,5-.61L254.23,208a2.49,2.49,0,0,1-2.17,2.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "248.181px 179.181px"
    },
    id: "elaw4q65twbfn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.16,184.6c-.61-2.24.54-2.57-.57-5.75-.59-1.69,1.35-3,1.59-1.64.9,4.95,7.47,7.72,5.19,10.85S250.76,186.84,250.16,184.6Z",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "253.163px 182.9px"
    },
    id: "elf4zh5eyf5gc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ell2mz95i9gp"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 238.13,
    cy: 97.23,
    r: 56.71,
    style: {
      fill: "rgb(68, 8, 78)",
      transformOrigin: "238.13px 97.23px",
      transform: "rotate(-86.41deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elj422pjfxfdh"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 238.13,
    cy: 97.23,
    r: 45.8,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "238.13px 97.23px",
      transform: "rotate(-70.49deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M267.87,89.49c-3.76-5.08-11,0-13.17,5.34A14.52,14.52,0,0,0,253.55,99l-2.39-16.31-1.89-15.46a5.15,5.15,0,0,0-10.22,1.25l-.47-3.85a5.14,5.14,0,1,0-10.21,1.26l.66,5.36a5.15,5.15,0,0,0-6.38-4.36h0a5.16,5.16,0,0,0-3.84,5.62l.82,6.69a5.14,5.14,0,0,0-6.38-4.36h0a5.14,5.14,0,0,0-3.83,5.61l1.64,13.37,1.17,9.59L213.78,116c1.1,9,4.61,14.08,9.82,16.37,8,3.51,22.65,3.55,29.23-1.79,5.76-4.67,9.46-15.92,10.35-22.89S269.4,91.54,267.87,89.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "238.763px 97.4713px"
    },
    id: "elcn61lgcn88",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3olkqigiqow"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232.21,
    y: 42.47,
    width: 11.85,
    height: 109.53,
    style: {
      fill: "rgb(68, 8, 78)",
      transformOrigin: "238.135px 97.235px",
      transform: "rotate(38.01deg)"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--error-unauthorized--inject-185",
    className: "animable",
    style: {
      transformOrigin: "151.878px 182.448px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.44,180.08v-18.2H93.61V164H82.85v5.58H92.92v2.14H82.85v6.19H94v2.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "87.22px 170.98px"
    },
    id: "el2kw0d0m4ozz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.05,180.08V166.89h2v2a5.55,5.55,0,0,1,1.42-1.85,2.45,2.45,0,0,1,1.43-.45,4.37,4.37,0,0,1,2.3.73l-.77,2.07a3.19,3.19,0,0,0-1.64-.48,2.07,2.07,0,0,0-1.31.44,2.4,2.4,0,0,0-.84,1.22,8.94,8.94,0,0,0-.37,2.61v6.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "100.625px 173.335px"
    },
    id: "elj85kvrwe4s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.52,180.08V166.89h2v2A5.55,5.55,0,0,1,109,167a2.47,2.47,0,0,1,1.43-.45,4.37,4.37,0,0,1,2.3.73l-.77,2.07a3.19,3.19,0,0,0-1.64-.48,2.07,2.07,0,0,0-1.31.44,2.4,2.4,0,0,0-.84,1.22,8.94,8.94,0,0,0-.37,2.61v6.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "109.125px 173.315px"
    },
    id: "elcz24fo3d4ze",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.18,173.49q0-3.66,2-5.43a6.1,6.1,0,0,1,4.14-1.47,5.91,5.91,0,0,1,4.45,1.79,6.79,6.79,0,0,1,1.73,4.92,8.74,8.74,0,0,1-.77,4,5.38,5.38,0,0,1-2.22,2.26,6.44,6.44,0,0,1-3.19.81,5.93,5.93,0,0,1-4.47-1.77A7.1,7.1,0,0,1,113.18,173.49Zm2.3,0a5.64,5.64,0,0,0,1.1,3.79,3.69,3.69,0,0,0,5.55,0,5.77,5.77,0,0,0,1.11-3.87,5.44,5.44,0,0,0-1.11-3.7,3.7,3.7,0,0,0-5.55,0A5.64,5.64,0,0,0,115.48,173.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "119.336px 173.481px"
    },
    id: "elwisfgxgdrbp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.13,180.08V166.89h2v2a5.42,5.42,0,0,1,1.42-1.85,2.45,2.45,0,0,1,1.43-.45,4.37,4.37,0,0,1,2.3.73l-.77,2.07a3.22,3.22,0,0,0-1.64-.48,2.1,2.1,0,0,0-1.32.44,2.39,2.39,0,0,0-.83,1.22,8.62,8.62,0,0,0-.37,2.61v6.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "131.705px 173.335px"
    },
    id: "elm5h1qi1vxjk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.75,202.69v-1.94A4.84,4.84,0,0,1,84.56,203a5.27,5.27,0,0,1-2.17-.45,3.62,3.62,0,0,1-1.51-1.12,4.54,4.54,0,0,1-.69-1.66,11.66,11.66,0,0,1-.13-2.09V189.5h2.23v7.31a13,13,0,0,0,.14,2.36,2.37,2.37,0,0,0,.89,1.39,2.82,2.82,0,0,0,1.69.5,3.72,3.72,0,0,0,1.89-.51,2.94,2.94,0,0,0,1.25-1.41,7.13,7.13,0,0,0,.36-2.57V189.5h2.24v13.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "85.4027px 196.251px"
    },
    id: "el8qsckajhia5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.25,202.69V189.5h2v1.87a4.76,4.76,0,0,1,4.2-2.17,5.38,5.38,0,0,1,2.19.43,3.49,3.49,0,0,1,1.5,1.12,4.53,4.53,0,0,1,.7,1.66,13.12,13.12,0,0,1,.12,2.17v8.11h-2.23v-8a5.84,5.84,0,0,0-.27-2,2.14,2.14,0,0,0-.92-1.08,2.92,2.92,0,0,0-1.56-.4,3.67,3.67,0,0,0-2.47.9c-.69.61-1,1.76-1,3.45v7.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "99.6075px 195.978px"
    },
    id: "elvqtt26ibewg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,201.06a8.2,8.2,0,0,1-2.4,1.49,6.84,6.84,0,0,1-2.46.44,4.79,4.79,0,0,1-3.34-1.07,3.48,3.48,0,0,1-1.17-2.71,3.64,3.64,0,0,1,1.6-3.05,5.28,5.28,0,0,1,1.61-.74,17.67,17.67,0,0,1,2-.33,20.57,20.57,0,0,0,4-.77c0-.31,0-.5,0-.59a2.46,2.46,0,0,0-.63-1.92,3.72,3.72,0,0,0-2.55-.76,4,4,0,0,0-2.33.55,3.38,3.38,0,0,0-1.11,2l-2.18-.3a5.22,5.22,0,0,1,1-2.26,4.23,4.23,0,0,1,2-1.33,8.81,8.81,0,0,1,3-.47,7.8,7.8,0,0,1,2.75.4,3.59,3.59,0,0,1,1.55,1,3.51,3.51,0,0,1,.7,1.52,13.2,13.2,0,0,1,.11,2.06v3a33.25,33.25,0,0,0,.14,4,5.18,5.18,0,0,0,.57,1.58h-2.34A4.7,4.7,0,0,1,117,201.06Zm-.19-5a16.41,16.41,0,0,1-3.65.84,8.56,8.56,0,0,0-2,.45,1.93,1.93,0,0,0-.88.73,1.88,1.88,0,0,0-.31,1.06,1.91,1.91,0,0,0,.67,1.49,2.89,2.89,0,0,0,2,.6,4.59,4.59,0,0,0,2.3-.57,3.51,3.51,0,0,0,1.48-1.55,5.37,5.37,0,0,0,.36-2.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "113.744px 196.118px"
    },
    id: "elq4jb47g5xv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.19,202.69v-1.94A4.84,4.84,0,0,1,127,203a5.35,5.35,0,0,1-2.18-.45,3.65,3.65,0,0,1-1.5-1.12,4.22,4.22,0,0,1-.69-1.66,11.45,11.45,0,0,1-.14-2.09V189.5h2.24v7.31a13,13,0,0,0,.14,2.36,2.37,2.37,0,0,0,.89,1.39,2.82,2.82,0,0,0,1.69.5,3.72,3.72,0,0,0,1.89-.51,2.94,2.94,0,0,0,1.25-1.41,7.13,7.13,0,0,0,.36-2.57V189.5h2.24v13.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "127.838px 196.251px"
    },
    id: "elmjku75aat37",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.57,200.69l.33,2a7.86,7.86,0,0,1-1.69.2,3.9,3.9,0,0,1-1.89-.38,2.22,2.22,0,0,1-.95-1,8,8,0,0,1-.27-2.63v-7.59h-1.64V189.5h1.64v-3.27l2.22-1.34v4.61h2.25v1.74h-2.25V199a3.82,3.82,0,0,0,.12,1.23.9.9,0,0,0,.39.43,1.45,1.45,0,0,0,.76.17A6.92,6.92,0,0,0,141.57,200.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "138.68px 193.893px"
    },
    id: "eld1beafwobx7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.76,202.69V184.48H146V191a5,5,0,0,1,3.95-1.81,5.28,5.28,0,0,1,2.55.58,3.45,3.45,0,0,1,1.55,1.59,7.41,7.41,0,0,1,.46,3v8.36h-2.23v-8.36a3.47,3.47,0,0,0-.73-2.44,2.71,2.71,0,0,0-2.06-.76,3.68,3.68,0,0,0-1.87.51,2.9,2.9,0,0,0-1.24,1.4,6.37,6.37,0,0,0-.38,2.43v7.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "149.14px 193.6px"
    },
    id: "el2b75od93ofh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.07,196.09q0-3.66,2-5.42a6.12,6.12,0,0,1,4.15-1.47A5.94,5.94,0,0,1,167.7,191a6.79,6.79,0,0,1,1.73,4.93,8.84,8.84,0,0,1-.76,4,5.36,5.36,0,0,1-2.23,2.27,6.43,6.43,0,0,1-3.18.81,5.91,5.91,0,0,1-4.48-1.78A7.09,7.09,0,0,1,157.07,196.09Zm2.3,0a5.67,5.67,0,0,0,1.1,3.8,3.56,3.56,0,0,0,2.79,1.26,3.51,3.51,0,0,0,2.77-1.27,5.77,5.77,0,0,0,1.1-3.86,5.46,5.46,0,0,0-1.11-3.71,3.69,3.69,0,0,0-5.55,0A5.59,5.59,0,0,0,159.37,196.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "163.247px 196.106px"
    },
    id: "el2kvp2aomwr8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,202.69V189.5h2v2a5.32,5.32,0,0,1,1.42-1.85,2.45,2.45,0,0,1,1.43-.45,4.36,4.36,0,0,1,2.3.72l-.77,2.08a3.12,3.12,0,0,0-1.64-.49,2.11,2.11,0,0,0-1.31.44,2.45,2.45,0,0,0-.84,1.22,9,9,0,0,0-.37,2.61v6.91Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "175.575px 195.945px"
    },
    id: "elbkisbosmlnn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.53,187.05v-2.57h2.24v2.57Zm0,15.64V189.5h2.24v13.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "181.65px 193.585px"
    },
    id: "elrnem9fij1ue",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,202.69v-1.81l8.4-9.64c-1,0-1.8.07-2.52.07h-5.38V189.5h10.78V191l-7.14,8.37-1.38,1.53q1.5-.12,2.82-.12h6.1v1.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "190.84px 196.105px"
    },
    id: "eli1f3qt730gn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.92,198.44l2.31.29a5.66,5.66,0,0,1-2,3.14,6.1,6.1,0,0,1-3.77,1.12,6,6,0,0,1-4.59-1.79,6.94,6.94,0,0,1-1.7-5,7.3,7.3,0,0,1,1.72-5.17,5.77,5.77,0,0,1,4.44-1.84,5.65,5.65,0,0,1,4.33,1.8,7.19,7.19,0,0,1,1.67,5.07c0,.13,0,.33,0,.6h-9.84a5.14,5.14,0,0,0,1.23,3.32,3.68,3.68,0,0,0,2.76,1.16,3.43,3.43,0,0,0,2.1-.65A4.3,4.3,0,0,0,207.92,198.44Zm-7.34-3.61h7.36a4.5,4.5,0,0,0-.84-2.5,3.43,3.43,0,0,0-2.77-1.29,3.54,3.54,0,0,0-2.59,1A4.07,4.07,0,0,0,200.58,194.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "204.25px 196.092px"
    },
    id: "elheselqfeklm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.59,202.69V201a4.09,4.09,0,0,1-3.69,2,5.19,5.19,0,0,1-2.9-.87,5.77,5.77,0,0,1-2.05-2.43,8.44,8.44,0,0,1-.72-3.58,9.41,9.41,0,0,1,.66-3.59,5.11,5.11,0,0,1,2-2.46,5.3,5.3,0,0,1,2.94-.86,4.47,4.47,0,0,1,2.13.5,4.58,4.58,0,0,1,1.51,1.31v-6.53h2.23v18.21Zm-7.06-6.58a5.7,5.7,0,0,0,1.06,3.78,3.24,3.24,0,0,0,2.52,1.26,3.15,3.15,0,0,0,2.49-1.2,5.49,5.49,0,0,0,1-3.66,6.22,6.22,0,0,0-1-4,3.21,3.21,0,0,0-2.57-1.27,3.09,3.09,0,0,0-2.49,1.22A6,6,0,0,0,214.53,196.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "217.964px 193.747px"
    },
    id: "elmrg0zk0w82l",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnauthorized);
export default __webpack_public_path__ + "static/media/Unauthorized.afb1398ebd3cca617d5fd8fdc569401b.svg";
export { ForwardRef as ReactComponent };